import { render, staticRenderFns } from "./RomaOrganizer.vue?vue&type=template&id=3b70133e"
import script from "./RomaOrganizer.vue?vue&type=script&lang=ts"
export * from "./RomaOrganizer.vue?vue&type=script&lang=ts"
import style0 from "./RomaOrganizer.vue?vue&type=style&index=0&id=3b70133e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports